/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const dealflowDecisionEntryDtoSchema = z.object({
  user: z.optional(z.string()),
  decision: z.optional(z.string()),
});
